import React, { useEffect, useRef, useState } from 'react'

export const RadioGroup = (props) => {
    let rowStyle = {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        display: 'flex',
        marginTop: 10,
    }
    let arr = []
    for (let i = 0; i < parseInt(props.range); i++) {
        arr.push(i + 1)
    }
    return (
        <>
            <div style={rowStyle}>
                <div style={{ flex: 1, textAlign: 'right', alignSelf: 'flex-end' }}>
                    {props.leftText}
                </div>
                {arr.map((ele) => (
                    <div style={{ flex: 1, flexDirection: 'column' }} key={`d${ele}`}>
                        <div style={rowStyle}>
                            <label style={{ margin: 0 }}>{ele}</label>
                        </div>
                        <div style={rowStyle}>
                            <input
                                key={`r${ele}`}
                                type='radio'
                                checked={props.defaultValue == ele}
                                disabled={props.disabled}
                                name={'optradio' + props.formSectionFieldId}
                                onChange={
                                    props.disabled
                                        ? null
                                        : (e) =>
                                              props.onChange({
                                                  target: {
                                                      value: ele.toString(),
                                                      setCustomValidity: () => null,
                                                  },
                                              })
                                }
                            />
                        </div>
                    </div>
                ))}
                {/* <div style={{flex:1, flexDirection:"column"}}>
            <label>
                Option 1
            </label>
            <div style={rowStyle}>
                <input type="radio" name="optradio"/>
            </div>
        </div>
        <div style={{flex:1, flexDirection:"column"}}>
            <label>
                Option 2
            </label>
            <div style={rowStyle}>
                <input type="radio" name="optradio"/>
            </div>
        </div>
        <div style={{flex:1, flexDirection:"column"}}>
            <label>
                Option 3
            </label>
            <div style={rowStyle}>
                <input type="radio" name="optradio"/>
            </div>
        </div> */}
                <div style={{ flex: 1, textAlign: 'left', alignSelf: 'flex-end' }}>
                    {props.rightText}
                </div>
            </div>
        </>
    )
}

export const RadioGroup2 = (props) => {
    let rowStyle = {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        display: 'flex',
        marginTop: 10,
    }
    let arr = []
    for (let i = 0; i < parseInt(props.range); i++) {
        arr.push(i + 1)
    }
    return (
        <div style={{ marginBottom: 30 }}>
            <div style={{ marginTop: 10 }}>{'aa'}</div>
            <div style={{ flex: 1, textAlign: 'right', alignSelf: 'flex-end' }}>
                {props.leftText}
            </div>
            <div style={rowStyle}>
                {/* <div style={{ flex: 1, textAlign: "right", alignSelf: "flex-end" }}>
                    {props.leftText}
                </div> */}
                {props.options.map((ele) => (
                    <div style={{ flex: 1, flexDirection: 'column' }} key={`d${ele.OptionValue}`}>
                        <div style={rowStyle}>
                            <label style={{ margin: 0 }}>{ele.OptionText}</label>
                        </div>
                        <div style={rowStyle}>
                            <input
                                key={`r${ele.OptionValue}`}
                                type='radio'
                                checked={props.defaultValue == ele}
                                disabled={props.disabled}
                                name={'optradio' + props.formSectionFieldId}
                                onChange={
                                    props.disabled
                                        ? null
                                        : (e) =>
                                              props.onChange({
                                                  target: {
                                                      value: ele.toString(),
                                                      setCustomValidity: () => null,
                                                  },
                                              })
                                }
                            />
                        </div>
                    </div>
                ))}
                {/* <div style={{flex:1, flexDirection:"column"}}>
            <label>
            Option 1
            </label>
            <div style={rowStyle}>
            <input type="radio" name="optradio"/>
            </div>
            </div>
            <div style={{flex:1, flexDirection:"column"}}>
            <label>
            Option 2
            </label>
            <div style={rowStyle}>
            <input type="radio" name="optradio"/>
            </div>
            </div>
            <div style={{flex:1, flexDirection:"column"}}>
            <label>
            Option 3
            </label>
            <div style={rowStyle}>
            <input type="radio" name="optradio"/>
            </div>
        </div> */}
                <div style={{ flex: 1, textAlign: 'left', alignSelf: 'flex-end' }}>
                    {props.rightText}
                </div>
            </div>
        </div>
    )
}

export const QuestionSection = (props) => {
    return (
        <div style={{ marginBottom: 30 }}>
            <div style={{ marginTop: 10 }}>{props.question}</div>
            <RadioGroup {...props} />
        </div>
    )
}

export const WrappedTextArea = (props) => {
    const [value, setValue] = useState(props.value)
    const [lastProps, setLastProps] = useState(props.value)
    // update with new props
    React.useEffect(() => {
        if (props.value && props.value !== lastProps && props.value !== value) {
            setValue(props.value)
            setLastProps(props.value)
        }
    }, [props.value])

    // this is what fieldCHangeFunc uses
    let fakeEvent = {
        preventDefault: () => null,
        target: {
            // removing this while fixing
            setCustomValidity: () => null,
            value: value,
        },
    }
    return (
        <textarea
            onChange={(e) => setValue(e.target.value)}
            value={value}
            onBlur={() => {
                props.onChange(fakeEvent)
                props.onBlur()
            }}
            className={props.className}
            onKeyPress={props.onKeyPress}
            disabled={props.disabled}
            onInvalid={props.onInvalid}
            rows={props.rows}
            cols={props.cols}
            maxLength={props.maxLength}
        />
    )
}

export const WrappedInput = (props) => {
    const [value, setValue] = useState(props.value)
    const [lastProps, setLastProps] = useState(props.value)
    // update with new props
    React.useEffect(() => {
        if (props.value && props.value !== lastProps && props.value != value) {
            setValue(props.value)
            setLastProps(props.value)
        }
    }, [props.value])


 
    let fakeEvent = {
        preventDefault: () => null,
        target: {
            // removing this while fixing
            setCustomValidity: () => null,
            value: value,
        },
    }
    return (
        <input
            onChange={(e) => setValue(e.target.value)}
            value={value}
            onBlur={() => {
                props.onChange(fakeEvent)
                props.onBlur()
            }}
            className={props.className}
            onKeyPress={props.onKeyPress}
            onInvalid={props.onInvalid}
            disabled={props.disabled}
            maxLength={props.maxLength}
        />
    )
}

export const WrappedNumericInput = (props) => {
    const [value, setValue] = useState(props.value)
    const [lastProps, setLastProps] = useState(props.value)
    // update with new props
    React.useEffect(() => {
        if (props.value !== lastProps) {
            if (props.value !== value) {
                setValue(props.value)
            }
            setLastProps(props.value)
        }
    }, [props.value, lastProps, value])

    // const step = props.numericStep

    const checkNumber = () => {
        // interpret " " as being "".
        if (value.trim() === '') return true
        if (isNaN(value)) {
            alert('Input is not a number')
            setValue(' ')
            return false
        }
      
        // DB won't store finer precision
        let step = props.step || 0.0001
        let smallest = step

      

        // mimic Chrome behavior by just removing non-numerics
        // let val = parseFloat(e.target.value);
        //        e.target.value = val;

        let val = parseFloat(value)
        // weird because of floating point in js
        let tens = 1
        let numDec = 0
        
        if (smallest <= 0) {
            alert('Tell IT')
            return
        }
        while (smallest < 1) {
            smallest = smallest * 10
            tens = tens * 10
            numDec += 1
        }
        let numDecVal
        let decimal = /\.(\w*)/.exec(value)
        if (decimal) {
            numDecVal = decimal[1].length
        } else {
            numDecVal = 0
        }
        if (numDecVal > numDec) {
            props.alertModal({ newValue: value, oldValue: props.value, step: step })

            // setValue(val.toFixed(numDec).toString())
            return false
        }
       
        return true
        
    }

    return (
        <input
            onChange={(e) => setValue(e.target.value)}
            value={value}
            onBlur={(e) => {
                let fakeEvent = {
                    preventDefault: () => null,
                    target: {
                        // removing this while fixing
                        setCustomValidity: () => null,
                        value: value.trim(),
                    },
                }

                let validNumber = checkNumber(value)
                if (!validNumber) setValue(props.value)
                else {
                    props.onChange(fakeEvent)
                }
            }}
            className={props.className}
            onKeyPress={props.onKeyPress}
            onInvalid={props.onInvalid}
            disabled={props.disabled}
        />
    )
}